module.exports = __webpack_public_path__ + "img/qr.7657c6e9.jpg";